import { useAppSelector } from '../../hooks/useAppSelector'
import { selectFilterFields } from '../../store/selectors/configChangesHistorySelectors'
import { useAppDispatch } from '../../hooks/useAppDispatch'
import { fetchConfigChangeHistory } from '../../store/async-thunks/configChangeHistory/fetchConfigChangeHistory'
import { useFormValidation } from '../../hooks/useFormValidation'
import { LoginFilter } from './LoginFilter'
import { configChangeHistoryActions } from '../../store/slices/configChangeHistorySlice'
import { StatusFilter } from './StatusFilter'
import { DateFromFilter } from './DateFromFilter'
import { DateToFilter } from './DateToFilter'
import { Col, Container, Row } from 'react-bootstrap'
import { getFiltersSchema } from './helpers'

interface Props {
    guid: string
}

export const ConfigChangeHistoryFilters = ({ guid }: Props) => {
    const dispatch = useAppDispatch()
    const filterFields = useAppSelector(selectFilterFields)
    const schema = getFiltersSchema()
    const [inputState, setInputState] = useFormValidation(filterFields, schema)

    const handleApply = () => {
        dispatch(configChangeHistoryActions.setFilters({ ...inputState, page: 1 }))
        dispatch(
            fetchConfigChangeHistory({
                productId: guid,
                from: inputState?.from,
                to: inputState?.to,
                login: inputState?.login,
                status: inputState?.status,
                limit: filterFields?.limit,
                page: 1,
            })
        )
    }

    return (
        <Container fluid>
            <Row className="gx-4">
                <Col>
                    <LoginFilter
                        inputState={inputState}
                        setInputState={setInputState}
                    />
                </Col>
                <Col>
                    <StatusFilter
                        inputState={inputState}
                        setInputState={setInputState}
                    />
                </Col>
                <Col>
                    <DateFromFilter
                        inputState={inputState}
                        setInputState={setInputState}
                    />
                </Col>
                <Col>
                    <DateToFilter
                        inputState={inputState}
                        setInputState={setInputState}
                    />
                </Col>
                <Col className="d-flex align-items-end pb-2">
                    <button
                        type="button"
                        onClick={handleApply}
                        style={{ marginBottom: '0.1rem' }}
                        className="app-btn-main app-btn-apply p-3"
                    >
                        Apply
                    </button>
                </Col>
            </Row>
        </Container>
    )
}
